import * as types from './mutations-types'

export default {
  [types.PRODUCT_HISTORY] (state, data) {
    console.log(data)
    state.productHistory = data
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/product-search/store/mutations.js